<tbody class="empty-tbody" *ngIf="totalItems === 0">
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span></td>
  </tr>
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span></td>
  </tr>
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span><span class="empty-warning h-small">조회된 데이타가 없습니다.</span></td>
  </tr>
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span></td>
  </tr>
  <tr>
    <td style="width: 100%;"><span>&nbsp;</span></td>
  </tr>
</tbody>